export default {
  'app.member': 'メンバー権限',
  'app.member.management': 'メンバー管理',
  'app.member.management.search': '検索フィルター',
  'app.member.management.invite': 'チームメンバーを招待',
  'app.member.management.invite.sso.tip':
    '組織はSSOログインを有効にしています。未付与ロールのメンバーは、自動的にデフォルトロールが付与されます。メンバーが参加した後、そのロールを変更できます。',
  'app.member.management.invite.edit': 'メンバーを編集',
  'app.member.management.invite.name.first': '名',
  'app.member.management.invite.name.first.placeholder': '招待者の名を入力',
  'app.member.management.invite.name.first.validate': '招待者の名を入力してください',
  'app.member.management.invite.name.last': '姓',
  'app.member.management.invite.name.last.placeholder': '招待者の姓を入力',
  'app.member.management.invite.name.last.validate': '招待者の姓を入力してください',
  'app.member.management.invite.email': 'メールアドレス',
  'app.member.management.invite.email.placeholder': '招待者のメールアドレスを入力',
  'app.member.management.invite.email.validate.empty': '招待者のメールアドレスを入力してください',
  'app.member.management.invite.email.validate.right': '有効なメールアドレスを入力してください',
  'app.member.management.invite.ssoConfig': '組織のSSOサービス',
  'app.member.management.invite.ssoConfig.placeholder': '組織のSSOサービスを選択',
  'app.member.management.invite.ssoConfig.validate': '組織のSSOサービスを選択してください',
  'app.member.management.invite.role': '役割',
  'app.member.management.invite.role.placeholder': '組織内の役割を選択して招待を送信',
  'app.member.management.invite.role.empty': '役割なし',
  'app.member.management.invite.role.create': '役割を追加',
  'app.member.management.invite.role.validate': '組織内の役割を選択して招待を送信してください',
  'app.member.management.invite.ok': '確認',
  'app.member.management.invite.cancel': 'キャンセル',
  'app.member.management.table.name': 'アカウント名',
  'app.member.management.table.id': 'アカウントID',
  'app.member.management.table.status': 'アカウント状態',
  'app.member.management.table.status.enable': '有効',
  'app.member.management.table.status.disable': '無効',
  'app.member.management.table.status.wait': '参加待ち',
  'app.member.management.table.time.last': '最終アクセス時間',
  'app.member.management.table.time.create': '作成時間',
  'app.member.management.table.operation': '操作',
  'app.member.management.table.operation.detail': '詳細',
  'app.member.management.table.operation.edit': '編集',
  'app.member.management.table.operation.resend': '招待を再送信',
  'app.member.management.table.operation.disable': '無効化',
  'app.member.management.table.operation.enable': '有効化',
  'app.member.management.table.operation.delete': '削除',
  'app.member.management.table.operation.delete.confirm':
    '削除後はアカウントが利用できなくなります',
  'app.member.management.table.operation.delete.confirm.ok': '削除を確認',
  'app.member.management.table.operation.delete.confirm.cancel': 'キャンセル',
  'app.member.management.table.operation.invite.success': '招待成功',
  'app.member.role': '役割管理',
  'app.member.role.create': '役割作成',
  'app.member.role.edit': '役割編集',
  'app.member.role.create.placeholder': '役割名を入力',
  'app.member.role.admin': '管理者',
  'app.member.role.rights': '権限',
  'app.member.role.members': 'メンバー',
  'app.member.role.name.placeholder': '役割名を入力してください',
  'app.member.role.creater': '作成者',
  'app.member.role.creater.validate': 'ユーザー名を入力してください',
  'app.member.role.console': 'コンソール',
  'app.member.role.empty': 'まだ作成されていない',
  'app.member.role.tip': 'グローバルロールは、デフォルトで各プロジェクトの事前設定ロールです。',
  'app.member.role.submit': '設定が正常に完了しました！',
  'app.member.role.save': '正常に保存されました！',
  'app.member.role.delete': '役割を削除すると、関連するメンバーの権限が無効になります',
  'app.member.role.delete.ok': '削除',
  'app.member.role.delete.cancel': 'キャンセル',
  'app.member.role.members.table.search': '検索フィルター',
  'app.member.role.members.table.name': 'アカウント名',
  'app.member.role.members.table.id': 'アカウントID',
  'app.member.role.members.table.emial': 'メールアドレス',
  'app.member.role.members.table.status': 'アカウント状態',
  'app.member.role.members.table.status.enable': '有効',
  'app.member.role.members.table.status.disable': '無効',
  'app.member.role.members.table.status.wait': '参加待ち',
  'app.member.role.members.table.time.last': '最終アクセス時間',
  'app.member.role.members.table.time.create': '作成時間',
  'app.member.role.members.table.operation': '操作',
  'app.member.role.members.table.operation.detail': '詳細',
  'app.member.role.members.table.operation.detail.title': 'メンバー詳細',
  'app.member.role.members.table.operation.detail.permission': '権限詳細',
  'app.member.role.members.table.operation.delete': '役割を削除',
  'app.member.role.permission.sharing': 'すべてのアプリケーションでロール権限を共有',
  'app.member.role.permission.sharing.tip':
    'チェックして保存すると、その役割の権限はすべてのアプリケーションで一貫性を保ちます',
  'app.member.management.create.org': '組織作成をメンバーに許可しますか？',
  'app.member.management.create.yes': 'はい',
  'app.member.management.create.no': 'いいえ',
  'app.member.roleCopy.copy': '役割をコピー',
  'app.member.roleCopy.title': '役割を他の組織にコピー',
  'app.member.roleCopy.select': '組織を選択',
  'app.member.roleCopy.selectTip': '組織を選択してください',
  'app.member.roleCopy.all': 'すべて選択',
  'app.member.roleCopy.success': 'コピーに成功しました！',
  'app.member.role.otp.target.tip': `<p>1）ターゲットが電話番号の場合:</p>
    <p>オペレーターにターゲットを表示する権限がない場合、履歴レコードに表示される番号はマスクされたバージョンになります。番号がマスクされると、番号文字列の最初の3桁と最後の2桁のみが表示されます。</p>
    <p>2）ターゲットがメールアドレスの場合：</p>
    <p>最初の2文字が表示され、メールアドレスの{'@'}以降は変更されません。</p>
    <p>例：</p>
    <p>otpsupport{'@'}engagelab.com</p>
    <p>マスク後は次のように表示されます:</p>
    <p>ot***{'@'}engagelab.com</p>
    `,
};
